export default __webpack_public_path__ + "static/people-f1b57afe248952494fa5aae823c8210f.png";